import Modal from '@Components/Shared/Modals/Modal';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const CallToActionModal = (props) => {

    return <Modal containerClassName="call-to-action" onEscapeKeyClose={props.closeModal}>
        <Modal.Header onClose={props.closeModal} />
        <Modal.Body>
            <div className="advertising-container cf">
                <LazyLoadImage src={props.ImageSourceUrl} alt={props.Header} className='call-to-action__image' />
                <div className="call-to-action__banner">
                    <div dangerouslySetInnerHTML={{ __html: props.Header }} />
                </div>
                <div dangerouslySetInnerHTML={{ __html: props.Description }} />
            </div>
        </Modal.Body>
        {props.CurrentWebsiteName == "LivestockMarket" &&
            <Modal.Footer>
                <div className="call-to-action__footer">
                    <button className="call-to-action__close" onClick={props.closeModal}>Close</button>
                    <button className="call-to-action__start" onClick={props.scrollToForm}>Let's Get Started</button>
                </div>
            </Modal.Footer>}
    </Modal>
}

export default CallToActionModal;